import React from 'react';
import {Grid, Tooltip, Typography} from '@mui/material';
import EquipmentTypeMap from './equipment/EquipmentTypeMap';
import '../../../css/components/locationProfilePriceBreakdown.css'
import InfoIcon from "@mui/icons-material/Info";
import {styled} from "@mui/material/styles";

const LocationProfileTitle = styled(Typography)(() => ({
    fontWeight: 500,
    fontSize: '1rem',
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));

const LocationProfileIcon = styled(InfoIcon)(() => ({
    marginLeft: '.3em',
    flexShrink: 0,
}));

const LocationProfilePriceBreakdown = (props) => {
    const { equipmentTypeArray, defaultPricePerDay, defaultPricePerMonth, loading } = props;

    const equipmentTypeInfo = "These are all types of equipment this facility can accept.";

    return (
        <Grid container className='ss-location-profile-pricing'>
            <Typography variant='h6' className="ss-location-profile-pricing-title">
                Prices
            </Typography>
            <Grid container>
                <div className="ss-location-profile-pricing-grid-titles">
                    <div className="ss-location-profile-pricing-subcontainer-icon-title">
                        <LocationProfileTitle variant='subtitle2'>
                            Equipment Type
                        </LocationProfileTitle>
                        <Tooltip title={equipmentTypeInfo} arrow placement="right">
                            <LocationProfileIcon color={'secondary'}/>
                        </Tooltip>
                    </div>
                    <Typography variant='subtitle2' className="ss-location-profile-pricing-header-cell">
                        Price / day
                    </Typography>
                    <Typography variant='subtitle2' className="ss-location-profile-pricing-header-cell">
                        Price / month
                    </Typography>
                </div>
                <EquipmentTypeMap
                    equipmentTypeArray={equipmentTypeArray}
                    defaultPricePerDay={defaultPricePerDay}
                    defaultPricePerMonth={defaultPricePerMonth}
                    loading={loading}
                />
            </Grid>
        </Grid>
    );
}

export default LocationProfilePriceBreakdown;
